import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { LocateFixed } from "lucide-react";

// Fix default marker icon paths (broken by default with webpack/CRA bundlers)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export default function MapLocationPicker({
  latitude,
  longitude,
  onChange,
  readOnly = false,
  height = 350,
}) {
  const [position, setPosition] = useState(
    latitude && longitude ? { lat: latitude, lng: longitude } : null,
  );

  useEffect(() => {
    if (latitude && longitude) {
      setPosition({
        lat: latitude,
        lng: longitude,
      });
    }
  }, [latitude, longitude]);

  function LocationMarker() {
    useMapEvents({
      click(e) {
        if (readOnly) return;

        setPosition(e.latlng);

        onChange?.(e.latlng.lat, e.latlng.lng);
      },
    });

    return position ? (
      <Marker
        position={position}
        draggable={!readOnly}
        eventHandlers={{
          dragend(e) {
            const marker = e.target.getLatLng();

            setPosition(marker);

            onChange?.(marker.lat, marker.lng);
          },
        }}
      />
    ) : null;
  }

  function RecenterMap({ position }) {
    const map = useMap();

    useEffect(() => {
      if (position) {
        map.setView(position, map.getZoom());
      }
    }, [position]);

    return null;
  }

  function getCurrentLocation() {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const newPos = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        setPosition(newPos);

        onChange?.(newPos.lat, newPos.lng);
      },
      (err) => {
        console.error(err);
        alert("Unable to retrieve your location");
      },
    );
  }

  return (
    <div className="flex flex-col gap-3 w-full">
      {!readOnly && (
        <button
          type="button"
          onClick={getCurrentLocation}
          className=" flex items-center gap-2 px-4 py-2 rounded-2xl bg-[#efe5df] text-sm font-medium text-[#051F33] transition-all duration-200 hover:bg-[#051F33] hover:text-white"
        >
          <LocateFixed className="h-4 w-4" />
          Use Current Location
        </button>
      )}

      <div className="w-full rounded-2xl overflow-hidden border border-[#efe5df]">
        <MapContainer
          center={position || [43.6532, -79.3832]}
          zoom={13}
          style={{ height, width: "100%" }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

          <LocationMarker />
          <RecenterMap position={position} />
        </MapContainer>
      </div>
    </div>
  );
}